// extracted by mini-css-extract-plugin
module.exports = {"container":"Features_container__h6tOc","headings":"Features_headings__AR0bY","heading":"Features_heading__E5l75"};